import script from "./contact.vue?vue&type=script&lang=ts&setup=true"
export * from "./contact.vue?vue&type=script&lang=ts&setup=true"

import "./contact.vue?vue&type=style&index=0&id=3b3760e0&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b3760e0"]])

export default __exports__